module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('a', {
    staticClass: "back-btn",
    attrs: {
      "href": "#/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "icon",
    style: ({
      'background-image': ("url(" + (_vm.staticDir + (_vm.album || _vm.icon)) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('a', {
    on: {
      "click": _vm.copyValue
    }
  }, [_vm._v(_vm._s(_vm.value))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36824f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 63
// module chunks = 1